// export const BASE_URL=`http://localhost:8000/api`;
export const baseURL = `https://homologsyngentabalconistaadmapi.rehagro.com.br/api`;
export const rememberPass = `https://homolog-aliancabalconista.rehagro.com.br/forgotpass`;
